import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, makeStyles, Checkbox } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import LoginScreenBanner from "../../shared-resources/images/LeftPanelLoginScreens.png";

function Logout() {
  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        overflow: "hidden",
      },
    },
    loginwrapper: {
      background: "#fff",
      textAlign: "center",
    },
    fieldStyle: {
      width: "60%",
      margin: "8px auto",
    },
    welcomeHead: {
      fontSize: theme.spacing(3),
      letterSpacing: "0px",
      color: "#3D3D3D",
      opacity: "1",
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },

    loginNote: {
      fontSize: theme.spacing(1.75),
      letterSpacing: "0px",
      marginBottom: theme.spacing(1.5),
    },

    welcomeWrapper: {
      marginTop: "6%",
    },
    loginBtn: {
      textTransform: "none",
      borderRadius: theme.spacing(3),
      background: "#0176D3 !important",
      fontWeight: 500,
      width: "120px",
      marginTop: theme.spacing(1),
      padding: "2px 0 !important",
    },
    fieldsGrid: {
      position: "relative",
    },
    bannerSection: {
      background: "#2354E8",
    },
    loginGrid: {
      height: window.innerHeight + 32,
    },
    loginBanner: {
      marginTop: "45%",
    },
  }));
  const classes = useStyles();

  const redirectLogin = () => {
    window.location.href = "/login";
  };

  useEffect(() => {
    localStorage.clear();
    sessionStorage.removeItem("reports_authed_session");
  }, []);

  return (
    <>
      <div className={classes.loginwrapper}>
        <Grid container spacing={4} className={classes.loginGrid}>
          <Grid
            item
            lg={6}
            className={classes.bannerSection}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: "100vh" }}
          >
            <div className={classes.loginBanner}>
              <img src={LoginScreenBanner} style={{ width: "330px" }} />
            </div>
          </Grid>
          <Grid
            item
            className={classes.fieldsGrid}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            lg={6}
          >
            <div>
              <div style={{ fontWeight: 500, fontSize: "16px" }}>
                You are now logged out of Financial Clarity.
              </div>
              <div style={{ fontWeight: 500, fontSize: "16px" }}>
                Click below to login again.
              </div>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                className={classes.loginBtn}
                onClick={redirectLogin}
                type="submit"
              >
                Login
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default Logout;
